import { t } from "@lingui/macro";
import { UrlDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";

import { toast } from "@/client/hooks/use-toast";
import { axios } from "@/client/libs/axios";

export const exportResumeDoc = async (data: { id: string }) => {
  const response = await axios.get<UrlDto>(`/resume/doc/${data.id}`);
  return response.data;
};

export const useExportResumeDoc = () => {
  const { error, isPending: loading, mutateAsync: exportDocFn } = useMutation({
    mutationFn: exportResumeDoc,
    onError: (error) => {
      const message = (error as any)?.message;
      toast({ variant: "error", title: t`Oops, the server returned an error.`, description: message });
    },
  });

  return { exportResumeDoc: exportDocFn, loading, error };
};


